<template>
  <div class="home">
    <!-- <TopNav/> -->
    <!-- <SideBar/> -->
  </div>
</template>

<script>
export default {
  name: 'Home',
  mounted() {
    this.$router.push('/login')
  }
}
</script>

<style lang="scss" scoped>
  @import "@/style/variables.scss";
  @import "@/style/home.scss";
</style>
